'use strict';

module.exports = function () {
    var selector = 'input:not([type="password"]):not(.search-field), textarea, [contenteditable], [contenteditable="true"]';
    var nameSelector = '#registration-form-fname, #registration-form-lname';

    function isCodeLike(text) {
        if (!text || typeof text !== 'string') return false;

        var score = 0;
        if (/(^|\s)(var|let|const)\s+[a-zA-Z_$]/i.test(text)) score += 1;
        if (/function\s*\(|=>/.test(text)) score += 1;
        if (/(\$\s*\(|document\.|window\.|querySelector\s*\()/i.test(text)) score += 1;
        if ((/[{};]{2,}/).test(text) || ((/[{};]/).test(text) && (/\([^)]+\)/).test(text))) score += 1;
        if (/<\/?\w+/.test(text)) score += 1;
        return score >= 2;
    }

    $(document).on('paste', selector, function (e) {
        var clipboard = (e.originalEvent && e.originalEvent.clipboardData) || window.clipboardData;
        try {
            var pasted = clipboard ? (clipboard.getData ? clipboard.getData('text/plain') : clipboard.getData('Text')) : '';
            if (isCodeLike(pasted)) {
                e.preventDefault();
                return false;
            }
        } catch (err) {
            // if fails
        }
        return true;
    });

    $(document).on('keypress', selector, function (e) {
        var blockedChars = '<>&"\'';
        if (blockedChars.indexOf(e.key) !== -1) {
            e.preventDefault();
            return false;
        }
        return true;
    });
    function sanitizeValue(value) {
        if (typeof value !== 'string') return value;

        value = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');

        value = value.replace(/on\w+\s*=\s*["'][^"']*["']/gi, '');

        value = value.replace(/\bjavascript:\s*/gi, '')
                     .replace(/\bdata:\s*/gi, '');

        value = value.replace(/[<>"'&\u003C\u003E\uFF1C\uFF1E\u2039\u203A]/g, '');

        value = value.replace(/[\`]/g, '');

        value = value.replace(/\b(alert|prompt|confirm|eval|Function|fetch|script)\b/gi, '');

        return value;
    }

    function sanitizeName(value) {
        if (typeof value !== 'string') return value;
        try {
            var unicodeLetters = new RegExp('[^\\p{L}\\p{M} \\-\']', 'gu');
            return value.replace(unicodeLetters, '');
        } catch (e) {
            return value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ \-']/g, '');
        }
    }

    $(document).on('paste input change', selector, function () {
        var $el = $(this);
        setTimeout(function () {
            if ($el.is('[contenteditable]')) {
                $el.text(sanitizeValue($el.text()));
            } else {
                $el.val(sanitizeValue($el.val()));
            }
        }, 0);
    });

    $(document).on('keypress', nameSelector, function (e) {
        var ch = e.key;
        if (e.ctrlKey || e.metaKey || e.altKey) return true;
        var allowBasic = (/^[A-Za-z \-']$/).test(ch);
        if (!allowBasic) {
            var obviousInvalid = (/[#!?_,.*/\\@\^\$%&()=+\[\]{}\"`~:;<>]/).test(ch);
            if (obviousInvalid) {
                e.preventDefault();
                return false;
            }
        }
        return true;
    });

    $(document).on('paste input change', nameSelector, function () {
        var $el = $(this);
        setTimeout(function () {
            $el.val(sanitizeName($el.val()));
        }, 0);
    });
};
